import { React, useEffect } from "react";
import { FooterNavigation, Header, PaginationHelper, TitleBar } from "webapp/components";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { AppState } from "webapp/enums/AppState";
import Modal from "react-responsive-modal";
import { ContractSelectionList } from "webapp/components/Partner/LDS/ContractSelectionList";
import { devLog } from "utils/devLog";

/**
 *
 * @param {
 * callBackFunc - callbackfunction that completes the submission of overall information
 * data - general data that populates the confirminfo value
 * confirmInfoDisab - legacy disablement update
 * confirmInfoDest - legacy destination update
 * onUserBack - original onUserBack which regresses the app to confirm destination, or
 *
 * backButtonFunc2 -
 * } props
 * @returns
 */
export default function PolicyInformation(props) {
  const { t } = useTranslation();

  const [policyData, setPolicyData] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectionMade, setSelectionMade] = useState(false);
  const [isSelectionModalOpen, setIsSelectionModalOpen] = useState(false);

  const [showFooter, setShowFooter] = useState(false);

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("description.PolicyInformationTitleBar1")}</strong>
          <br />
          {/* <span className="alt-text-main">
            {t("description.PolicyInformationTitleBar2")}
          </span> */}
        </p>
      </>
    ),
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onUserNext = () => {
    devLog("onUserNext");
    /*if(typeof props.onUserNext === 'function'){
      props.onUserNext();
    }*/

    if (!selectionMade) {
      setIsSelectionModalOpen(true);
      return;
    }

    devLog(selectedVehicle);
    if (selectedVehicle) {
      props.context.setState(
        {
          ContractNumber: selectedVehicle.contractNumber,
          Year: selectedVehicle.year,
          Make: selectedVehicle.make,
          Model: selectedVehicle.model,
          Color: "",
          VIN: selectedVehicle.vin,
          allowVehicleInfoEdits: false,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          props.context.saveWebAppState(props.context);
        },
      );
    } else {
      props.context.setState(
        {
          ContractNumber: null,
          Year: "",
          Make: "",
          Model: "",
          Color: "",
          VIN: "",
          allowVehicleInfoEdits: true,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {},
      );
    }
  };

  const onUserSelectVehicle = (policy, vehicle) => {
    devLog("onUserSelectVehicle", policy, vehicle);
    setPolicyData(policy);
    setSelectedVehicle(vehicle);
    setSelectionMade(typeof vehicle === "undefined" ? false : true);
  };

  const onContractLookupComplete = (success) => {
    setShowFooter(!!success);
  };

  return (
    <div className="CustCollectPage">
      <Header
        currState={props.currState}
        onUserBack={props.onUserBack}
        information={t("description.PolicyInformationHeader1")}
      />
      <TitleBar data={LocateUserObj} />
      <PaginationHelper context={props.context} />
      <ContractSelectionList
        currState={props.currState}
        onSelect={onUserSelectVehicle}
        onUserBack={props.onUserBack}
        onLoad={onContractLookupComplete}
      />
      <Modal
        className={`policy-loader-modal`}
        open={isSelectionModalOpen}
        onClose={() => {
          setIsSelectionModalOpen(false);
        }}
      >
        <h2 style={{ marginTop: 30 }}>{t("description.PolicyInformationHeader1")}</h2>
        <div>{t("description.PolicyInformationPleaseMakeSelection")}</div>
      </Modal>
      {showFooter ? <FooterNavigation onCancelClick={onUserCancel} onNextClick={onUserNext} /> : <></>}
    </div>
  );
}
